module.exports = __webpack_public_path__ + "img/Logo-martinez-horizontal.405485b5.png";